<template>
  <BCard>
    <div class="text-[#333333] text-[20px] font-semibold">
      Data Partner Komads
    </div>
    <div class="flex justify-end items-center overflow-x-auto">
      <div class="flex items-center gap-5">
        <div
          class="flex items-center !w-[300px] rounded-[8px] gap-[5px] px-[8px]  border-[1px] border-[#E2E2E2] h-[40px]"
        >
          <span
            class="k-search-normal-1 font-bold align-middle"
            style="font-size: 20px"
          />
          <BFormInput
            v-model="search"
            placeholder="Cari Nama, Email, No. Handphone"
            class="border-0 grow"
            @input="searchData"
          />
        </div>
        <div class="flex items-center flex-row">
          <BButton
            id="filter"
            size="sm"
            variant="primary"
            class="position-relative"
            @click="set => (dropdownFilter = !dropdownFilter)"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
              alt="Komerce"
              width="20"
            >
            <span
              v-if="activeFilterCount > 0"
              class="bg-[#F95031] -top-4 badge position-absolute start-100 translate-middle rounded-pill"
            >
              <span class="text-white font-semibold">{{
                activeFilterCount
              }}</span>
            </span>
          </BButton>
          <ul
            v-if="dropdownFilter"
            class="d-block position-absolute bg-[#f9f9f9] right-[10px] top-[100px] z-10 text-black font-medium text-[12px] pb-1 rounded-xl"
          >
            <div class="text-black pl-2 py-1 text-[16px] border rounded-t-xl">
              Filter
            </div>
            <div
              class="hover:bg-[#FCD4BE] relative"
              tabindex="-1"
              @focusin="isPlaformFilterFocused = true"
              @focusout="event => {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                  isPlaformFilterFocused = false
                }
              }"
            >
              <div
                class="btn d-flex w-100"
                role="button"
                tabindex="0"
              >
                <span>Platform Iklan</span>
                <div
                  v-if="filledSelectedPlatforms.length > 0"
                  class="text-primary ml-[5px]"
                >
                  ({{ selectedPlatforms.length }})
                </div>
              </div>
              <div
                :class="isPlaformFilterFocused ? 'block' : 'hidden'"
                class="absolute right-[calc(100%_+_5px)] bottom-0 bg-white min-w-[240px] p-[1rem] border rounded-md shadow space-y-[1rem]"
              >
                <div
                  v-for="(item, index) in platformOptions"
                  :key="index"
                >
                  <b-form-checkbox
                    v-model="selectedPlatforms"
                    :value="item.value"
                    class="custom-control-primary"
                    name="partner-checkbox"
                  >
                    <span class="text-[#333333] hover:cursor-pointer">
                      {{ item.text }}
                    </span>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
            <div class="hover:bg-[#FCD4BE]">
              <div
                id="popoverSpendingRangeFilter"
                class="btn d-flex w-100"
                role="button"
                tabindex="0"
              >
                <span>Range Spending</span>
                <div
                  v-if="spendingRange.min || spendingRange.max"
                  class="text-primary ml-[5px]"
                >
                  (1)
                </div>
              </div>
              <b-popover
                target="popoverSpendingRangeFilter"
                triggers="focus"
                placement="left"
              >
                <div class="d-flex flex-column gap-2">
                  <b-form-group
                    label="Minimum"
                    label-for="spending-range-min"
                    class="font-bold mb-1"
                  >
                    <b-form-input
                      id="spending-range-min"
                      ref="spending-range-min"
                      :value="spendingRange.min"
                      type="number"
                      placeholder="Rp0"
                      class="custom-control-primary"
                      @input="value => {
                        spendingRange.min = maxDigit(value, 'spending-range-min')
                      }"
                    />
                  </b-form-group>
                  <b-form-group
                    label="Maximum"
                    label-for="spending-range-max"
                    class="font-bold mb-1"
                  >
                    <b-form-input
                      id="spending-range-max"
                      ref="spending-range-max"
                      :value="spendingRange.max"
                      type="number"
                      placeholder="Rp0"
                      class="custom-control-primary"
                      @input="value => {
                        spendingRange.max = maxDigit(value, 'spending-range-max')
                      }"
                    />
                  </b-form-group>
                </div>
              </b-popover>
            </div>
            <div class="hover:bg-[#FCD4BE]">
              <div
                id="popoverAccountTypeFilter"
                class="btn d-flex w-100"
                role="button"
                tabindex="0"
              >
                <span>Verifikasi Akun</span>
                <div
                  v-if="selectedAccountType !== null"
                  class="text-primary ml-[5px]"
                >
                  (1)
                </div>
              </div>
              <b-popover
                target="popoverAccountTypeFilter"
                triggers="focus"
                placement="left"
              >
                <div
                  v-for="(item, index) in accountTypeOptions"
                  :key="index"
                >
                  <b-form-radio
                    v-model="selectedAccountType"
                    :value="item.value"
                    class="custom-control-primary mb-1"
                    name="partner-radio"
                  >
                    <span class="text-black">
                      {{ item.text }}
                    </span>
                  </b-form-radio>
                </div>
              </b-popover>
            </div>
            <div class="hover:bg-[#FCD4BE]">
              <date-range-picker
                ref="picker"
                v-model="dateRange"
                :locale-data="locale"
                :ranges="ranges"
                :max-date="new Date()"
                :opens="'left'"
                class="w-100"
                control-container-class="border-0"
              >
                <template v-slot:input>
                  <div class="d-flex btn">
                    <span>Tanggal</span>
                    <div
                      v-if="dateRange.startDate && dateRange.endDate"
                      class="text-primary ml-[5px]"
                    >
                      (1)
                    </div>
                  </div>
                </template>
              </date-range-picker>
            </div>
            <div class="border-t-2 pt-1 justify-between d-flex gap-4 px-1">
              <b-button
                variant="outline-primary"
                class="w-40 rounded-lg"
                @click="resetFilter"
              >
                Reset Filter
              </b-button>
              <b-button
                type="submit"
                variant="primary"
                class="w-40 rounded-lg"
                @click="fetchData"
              >
                Terapkan
              </b-button>
            </div>
          </ul>
        </div>
      </div>
    </div>
    <div class="mt-[16px]">
      <DataPartnerTable
        :items="items"
        :loading="loadingTable"
        @view-detail="viewDetail"
        @scroll="handleScroll"
      />
    </div>
  </BCard>
</template>

<script>
import { DAY_MONTH_YEAR, YEAR_MONTH_DAY } from '@/libs/filterDate'
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import { mapState } from 'vuex'
import DateRangePicker from 'vue2-daterange-picker'
import {
  firstDateOfMonth, today, yesterday, last7,
} from '@/store/helpers'
import { columnConfig } from './config'
import DataPartnerTable from './Table.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  components: {
    DateRangePicker,
    DataPartnerTable,
  },
  data() {
    return {
      DAY_MONTH_YEAR,
      IDR,
      fields: columnConfig,
      loadingTable: false,
      lastData: false,
      limit: 25,
      offset: 0,
      items: [],

      selectedPlatforms: [],
      platformOptions: [
        { value: null, text: 'Semua' },
        { value: 'meta', text: 'Meta' },
        { value: 'tiktok', text: 'Tiktok' },
        { value: 'google', text: 'Google' },
      ],
      selectedAccountType: null,
      accountTypeOptions: [
        { value: null, text: 'Semua' },
        { value: 'verified', text: 'Terverifikasi' },
        { value: 'unverified', text: 'Belum Terverifikasi' },
      ],
      spendingRange: {
        min: 0,
        max: 1,
      },
      search: null,
      dropdownFilter: false,
      dateRange: {
        startDate: undefined,
        endDate: undefined,
      },
      locale: {
        format: 'dd/mm/yyyy',
        applyLabel: 'Terapkan',
        cancelLabel: 'Batal',
        customRangeLabel: 'Custom Range',
      },
      ranges: {
        'Hari ini': [today, today],
        Kemarin: [yesterday, yesterday],
        '7 Hari Terakhir': [last7, today],
        'Bulan ini': [firstDateOfMonth, today],
      },
      isInDetail: false,
      updatingPlatform: false,
      isPlaformFilterFocused: false,
    }
  },
  computed: {
    ...mapState('filterKomads', [
      'searchHistory',
      'currentPageHistory',
      'perPageHistory',
      'dateRangeHistory',
      'filledPlatformsHistory',
      'spendingRangeHistory',
      'accountTypeHistory',
    ]),
    activeFilterCount() {
      let count = 0
      if (this.filledSelectedPlatforms.length > 0) count += 1
      if (this.spendingRange.min || this.spendingRange.max) count += 1
      if (this.selectedAccountType !== null) count += 1
      if (this.dateRange.startDate && this.dateRange.endDate) count += 1
      return count
    },
    filledSelectedPlatforms() {
      return this.selectedPlatforms.filter(item => item)
    },
  },
  watch: {
    selectedPlatforms(newVal, oldVal) {
      if (this.updatingPlatform) return

      this.updatingPlatform = true

      const ALL = null
      const allPlatforms = this.platformOptions
        .filter(i => i.value !== ALL)
        .map(i => i.value)

      const hasAll = newVal.includes(ALL)
      const hadAll = oldVal.includes(ALL)

      if (hasAll && !hadAll) {
        this.selectedPlatforms = [ALL, ...allPlatforms]
      } else if (!hasAll && hadAll) {
        this.selectedPlatforms = []
      } else if (hasAll) {
        this.selectedPlatforms = newVal.filter(v => v !== ALL)
      } else if (allPlatforms.every(v => newVal.includes(v))) {
        this.selectedPlatforms = [ALL, ...allPlatforms]
      }

      this.$nextTick(() => {
        this.updatingPlatform = false
      })
    },
  },
  mounted() {
    this.validateParams()
  },
  beforeDestroy() {
    if (!this.isInDetail) this.resetFilterStates()
  },
  methods: {
    maxDigit(value, ref) {
      let val = String(value || '')
      val = val.replace(/\D/g, '')
      val = val.slice(0, 12)
      this.$refs[ref].localValue = val
      return val
    },
    validateParams() {
      let hasFilter = false

      // Apply search filter if exists
      if (this.searchHistory !== '') {
        this.search = this.searchHistory
        hasFilter = true
      }

      // Apply date range filter if exists
      if (this.dateRangeHistory !== null) {
        this.dateRange = {
          startDate: this.dateRangeHistory.startDate,
          endDate: this.dateRangeHistory.endDate,
        }
        hasFilter = true
      }

      // Apply selected platforms if exist
      if (this.filledPlatformsHistory.length > 0) {
        this.selectedPlatforms = this.filledPlatformsHistory
        hasFilter = true
      }

      // Apply spending range if exist
      if (this.spendingRangeHistory !== null) {
        this.spendingRange = {
          min: this.spendingRangeHistory.min,
          max: this.spendingRangeHistory.max,
        }
        hasFilter = true
      }

      // Apply account type if exist
      if (this.accountTypeHistory !== null) {
        this.selectedAccountType = this.accountTypeHistory
        hasFilter = true
      }

      // If search filter is applied, use searchData method which includes debounce
      if (hasFilter && this.searchHistory !== '') {
        this.searchData(this.search)
      } else {
        // Otherwise just get the data with all applied filters
        this.getListDataPartner()
      }
    },

    async getListDataPartner() {
      this.loadingTable = true

      // Save current parameters to store
      this.$store.dispatch('filterKomads/updateSearchHistory', this.search)
      this.$store.dispatch(
        'filterKomads/updateDateRangeHistory',
        this.dateRange,
      )
      this.$store.dispatch('filterKomads/updateFilledPlatformsHistory', this.selectedPlatforms)
      this.$store.dispatch('filterKomads/updateSpendingRangeHistory', this.spendingRange)
      this.$store.dispatch('filterKomads/updateAccountTypeHistory', this.selectedAccountType)

      const params = {
        limit: this.limit,
        offset: this.offset,
        keyword: this.search,
        start_date: this.dateRange.startDate
          ? YEAR_MONTH_DAY(this.dateRange.startDate)
          : null,
        end_date: this.dateRange.endDate
          ? YEAR_MONTH_DAY(this.dateRange.endDate)
          : null,
        platform_names: this.filledSelectedPlatforms.length > 0 ? this.filledSelectedPlatforms : '',
        min_spending: this.spendingRange.min,
        max_spending: this.spendingRange.max,
        is_verified_ktp: this.selectedAccountType ? this.selectedAccountType === 'verified' : '',
      }

      await newAxiosIns
        .get('komads/api/v1/admin/partners/list', { params })
        .then(res => {
          const { data } = res.data
          this.items = data
          this.offset += data.length
          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
          this.loadingTable = false
        })
        .catch(err => {
          this.loadingTable = false
          this.items = []
        })
    },
    handleScroll(event) {
      const table = event.target || document.getElementById('table')
      if (
        table.scrollTop >= table.scrollHeight - table.offsetHeight - 20
        && !this.loadingTable
        && !this.lastData
      ) {
        this.getNextData()
      }
      if (table.scrollTop === 0) {
        setTimeout(() => {
          table.scrollTop = 1
          setTimeout(() => {
            table.scrollTop = 0
          }, 10)
        }, 10)
      }
    },
    getNextData() {
      if (!this.lastData) {
        this.loadingTable = true
        const params = {
          limit: this.limit,
          offset: this.offset,
          keyword: this.search,
          start_date: this.dateRange.startDate
            ? YEAR_MONTH_DAY(this.dateRange.startDate)
            : null,
          end_date: this.dateRange.endDate
            ? YEAR_MONTH_DAY(this.dateRange.endDate)
            : null,
          platform_names: this.filledSelectedPlatforms.length > 0 ? this.filledSelectedPlatforms : '',
          min_spending: this.spendingRange.min,
          max_spending: this.spendingRange.max,
          is_verified_ktp: this.selectedAccountType ? this.selectedAccountType === 'verified' : '',
        }

        newAxiosIns
          .get('komads/api/v1/admin/partners/list', { params })
          .then(res => {
            const { data } = res.data
            this.items.push(...data)
            this.offset += data.length
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .finally(() => {
            this.loadingTable = false
          })
      }
    },
    searchData: _.debounce(function search() {
      this.offset = 0
      this.lastData = false
      this.getListDataPartner()
    }, 1000),

    resetFilterStates() {
      this.search = null
      this.dateRange = {
        startDate: undefined,
        endDate: undefined,
      }
      this.offset = 0
      this.lastData = false
      this.selectedPlatforms = []
      this.spendingRange.min = null
      this.spendingRange.max = null
      this.selectedAccountType = null

      this.$store.dispatch('filterKomads/updateSearchHistory', this.search)
      this.$store.dispatch(
        'filterKomads/updateDateRangeHistory',
        this.dateRange,
      )
      this.$store.dispatch('filterKomads/updateFilledPlatformsHistory', this.selectedPlatforms)
      this.$store.dispatch('filterKomads/updateSpendingRangeHistory', this.spendingRange)
      this.$store.dispatch('filterKomads/updateAccountTypeHistory', this.selectedAccountType)
    },

    resetFilter() {
      this.resetFilterStates()
      this.fetchData()
    },

    fetchData() {
      this.offset = 0
      this.lastData = false
      this.getListDataPartner()
      this.dropdownFilter = false
      const table = document.getElementById('table')
      if (table.scrollTop > 0) table.scrollTop = 0
    },

    viewDetail(id) {
      this.isInDetail = true
      this.$router.push(`/komads/data-partner/${id}`)
    },
  },
}
</script>
